import DTO from './DTO';
import DtoType from './converters/DtoType';
import FIODTO from './FIODTO';
import IdentityDocumentDTO from './IdentityDocumentDTO';
import {
  inn12,
  maxLength12, minLength10,
  noLetters, noSpaceEnd, noSpaceStart,
  number,
  onlyDigits,
  required,
  trimError,
  trimNoSpecStartOrEnd,
} from '../utils/validation';

class PersonDTO extends DTO {
  constructor(params, isValidInit) {
    const fioAttr = new FIODTO().getAttributes();
    const attributes = [
      ...fioAttr,
      {
        name: 'birth_date',
        type: String,
        validators: [],
        labelKey: 'birth_date',
        couldBeNull: true,
      },
      {
        name: 'place_of_birth',
        type: String,
        validators: [],
        labelKey: 'place_of_birth',
        couldBeNull: true,
      },
      {
        name: 'gender',
        type: Number,
        validators: [],
        labelKey: 'gender',
        couldBeNull: true,
      },
      {
        name: 'isMatch',
        type: Boolean,
        validators: [],
        labelKey: 'isMatch',
        couldBeNull: true,
      },
      {
        name: 'citizenship',
        type: Number,
        validators: [],
        labelKey: 'citizenship',
        couldBeNull: true,
      },
      {
        name: 'phone',
        type: String,
        validators: [required],
        labelKey: 'phone',
        couldBeNull: true,
      },
      {
        name: 'email',
        type: String,
        validators: [],
        labelKey: 'pd.email',
        couldBeNull: true,
      },
      {
        name: 'identity_type',
        type: Number,
        validators: [],
        labelKey: 'identity_type',
        couldBeNull: true,
      },
      {
        name: 'identity_series',
        type: String,
        validators: [],
        labelKey: 'identity_series',
        couldBeNull: true,
      },
      {
        name: 'identity_number',
        type: String,
        validators: [],
        labelKey: 'identity_number',
        couldBeNull: true,
      },
      {
        name: 'identity_issue_date',
        type: String,
        validators: [],
        labelKey: 'identity_issue_date',
        couldBeNull: true,
      },
      {
        name: 'identity_issuer',
        type: String,
        validators: [],
        labelKey: 'identity_issuer',
        couldBeNull: true,
      },
      {
        name: 'applicant_identity_files',
        type: String,
        validators: [],
        labelKey: 'media.applicant_identity_files',
        couldBeNull: true,
      },
      {
        name: 'representative_identity_files',
        type: String,
        validators: [],
        labelKey: 'representative_identity_files',
        couldBeNull: true,
      },
      {
        name: 'address',
        type: String,
        validators: [],
        labelKey: 'address',
        couldBeNull: true,
      },
      {
        name: 'fact_address',
        type: String,
        validators: [],
        labelKey: 'fact_address',
        couldBeNull: true,
      },
      {
        name: 'office_address',
        type: String,
        validators: [],
        labelKey: 'office_address',
        couldBeNull: true,
      },
      {
        name: 'registration_type',
        type: Number,
        validators: [],
        labelKey: 'registration_type',
        couldBeNull: true,
      },
      {
        name: 'snils',
        type: String,
        validators: [],
        labelKey: 'snils',
        couldBeNull: true,
      },
      {
        name: 'inn',
        type: String,
        validators: [required, onlyDigits, noLetters, trimError, trimNoSpecStartOrEnd, noSpaceStart, noSpaceEnd, inn12],
        labelKey: 'inn',
        couldBeNull: true,
      },
      {
        name: 'legal_entity_form',
        type: String,
        validators: [],
        labelKey: 'legal_entity_form',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return this;
  }
}

export default PersonDTO;
